import React, { useState, useEffect } from "react"

import { loadStripe } from "@stripe/stripe-js"
import { Elements } from "@stripe/react-stripe-js"

export const withStripe = Component => {
  const WithStripeComponent = props => {
    const [stripeLoader, setStripeLoader] = useState(null)

    useEffect(() => {
      if (!stripeLoader) {
        setStripeLoader(loadStripe(process.env.GATSBY_STRIPE_PUBLISHABLE_KEY))
      }
    }, [stripeLoader])

    return (
      <Elements locale="en" stripe={stripeLoader}>
        <Component isStripeLoading={!stripeLoader} {...props} />
      </Elements>
    )
  }

  WithStripeComponent.displayName = `WithStripe(${Component.displayName})`
  return WithStripeComponent
}
